import React from "react";

import { GridResult } from "2g-grid";

import useDoplnkoveSluzbyGrid from "./useDoplnkoveSluzbyGrid";

export function DoplnkoveSluzbyGrid() {
  const grid = useDoplnkoveSluzbyGrid();
  return <GridResult {...grid} />;
}

DoplnkoveSluzbyGrid.propTypes = {};

export default React.memo(DoplnkoveSluzbyGrid);
